import template from './privacy-policy.tpl.pug';

class PrivacyPolicyController {
    /* @ngInject */
    constructor($state, configuration) {
        this.$state = $state;
        this.configuration = configuration;
    }

    $onInit() {
        this.salesEmail = this.configuration.salesEmail;
        this.landingUrl = this.$state.href('landing');
    }
}

export default {
    selector: 'dbLPrivacyPolicy',
    template: template(),
    controller: PrivacyPolicyController
};



// WEBPACK FOOTER //
// ./src/legal/scene/privacy-policy/privacy-policy.cmpt.js